export const getTPStatisticsAPI="/tps-statistics";
export const getJobsStatisticsAPI="/jobs-statistics";
export const getUsersStatisticsAPI="/users-statistics";
export const getPublishersStatisticsAPI="/publishers-statistics";